import clsx from 'clsx';

import { NavButton, type NavButtonOption } from './NavButton';

import type { DetailedHTMLProps, MenuHTMLAttributes } from 'react';

import s from './NavMenu.module.css';

export type NavMenuItem = Omit<NavButtonOption, 'isActive' | 'onClick'> & { id: string };

type NavMenuProps<T extends Readonly<NavMenuItem[]>> = DetailedHTMLProps<
  MenuHTMLAttributes<HTMLElement>,
  HTMLElement
> & {
  items: T;
  activeId?: T[number]['id'];
  disabled?: boolean;
  onItemClick?: (id: T[number]['id']) => void;
};

export const NavMenu = <T extends Readonly<NavMenuItem[]>>({
  activeId,
  className,
  items,
  onItemClick,
  ...props
}: NavMenuProps<T>) => {
  const handleItemClick = (id: T[number]['id']) => () => onItemClick?.(id);
  const activeIndex = items.findIndex((item) => item.id === activeId);

  return (
    <menu className={clsx(s.navMenu, className)} {...props}>
      {items.map(({ id, ...navButtonProps }, index) => (
        <NavButton key={index} isActive={id === activeId} onClick={handleItemClick(id)} {...navButtonProps} />
      ))}

      {activeIndex !== -1 && (
        <div className={s.activeIndicator} style={{ transform: `translateX(${activeIndex * 100}%)` }} />
      )}
    </menu>
  );
};
